/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import DateRange from '@material-ui/icons/DateRange';
import { ButtonBase } from '@material-ui/core';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useStyles from './styles';

const DateIcon = (props) => {
  const { customProps, onClick, size } = props;
  const classes = useStyles({ size });
  return (
    <ButtonBase {...customProps} onClick={onClick} className={classnames(classes.button, customProps.button)}>
      <DateRange />
    </ButtonBase>
  );
};

DateIcon.propTypes = {
  onClick: PropTypes.func,
  customProps: PropTypes.object,
  size: PropTypes.number.isRequired,
};

DateIcon.defaultProps = {
  customProps: {},
  size: 15,
};

export default DateIcon;
